import styled from "styled-components";
import {
  ButtonHeader,
  CardRecent,
} from "../components/pageComponents/dashboard";
import { MoreIcon, SmallRightIcon } from "../assets/icons/Icons";
import Navbar from "../components/Nabvar";
import Footer from "../components/Footer";
import { SearchBar } from "../components/ui";
import { CardSiniestros } from "../components/pageComponents/dashboard/CardSiniestros";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useState, useEffect } from "react";
import { GET_CONTRACT, GET_REMINDERS, GET_SINIESTERS } from "../services/contract/contracts";
import { GET_SINEISTROS, GET_SINISTER_BY_ID } from "../services/siniestro";
import { ModalReminder } from "../components/form";
import { UPDATE_REMINDER } from "../services/siniestro";
import { useNavigate } from "react-router-dom";
import ModalWrapper from "../components/ModalContainer";
import { useContract } from "../redux/contractReducer";
import { useSiniester } from "../redux/siniesterReducer";

const Container = styled.div`
  width: 100%;
  position: relative;
  min-height: calc(100vh - 62px);
  padding-top: 70px;
  margin-bottom: 100px;
`;

//---- HEADER ----//
const HeaderWrapper = styled.div`
  background-color: var(--primary-royal-blue);
  display: grid;
  place-content: center;
`;
const Header = styled.div`
  width: 1200px;
  background-color: var(--primary-royal-blue);
  padding: 56px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
  @media only screen and (max-width: 1280px) {
    width: 90vw;
  } ;
`;
const LeftHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  @media only screen and (max-width: 700px) {
    width: 100%;
    align-items: center;
  } ;
`;

const RightHeader = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  @media only screen and (max-width: 999px) {
    flex-direction: column;
    margin-top: 36px;
    width: 100%;
  } ;

`;

const Title = styled.h1`
  color: #fff;
  line-height: 26px;
`;

// const Subtitle = styled.p`
//   color: #fff;
// `;
// const ScheduleText = styled.span`
//   color: #fff;
//   background-color: var(--secondary-forest-green);
//   padding: 8px 24px;
//   border-radius: 20px;
//   font-weight: 700;
//   font-size: 14px;
// `;

//---- RECENTS ----//
const RecentsWrapper = styled.div`
  width: 100%;
  display: grid;
  place-content: center;
  position: relative;
  &:after {
    background-color: var(--primary-royal-blue);
    content: "";
    top: 0;
    height: 200px;
    width: 100%;
    position: absolute;
    z-index: -1;
  }
`;

const RecentsContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: rgba(99, 99, 99, 0.1) 0px 2px 4px 0px;
  @media only screen and (max-width: 1280px) {
    width: 100vw;
    padding: 40px 20px;
  }
`;

const RecentsTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: var(--primary-pistachio);
`;

const CardsContainer = styled.div`
  display: grid;
  grid-gap: 16px;
  padding: 12px;
  grid-template-columns: repeat(auto-fill, minmax(18%, 1fr));
  grid-auto-flow: column;
  grid-auto-columns: minmax(18%, 1fr);
  overflow-x: auto;
  @media only screen and (max-width: 620px) {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
  }

  @media only screen and (min-width:621px) and (max-width:999px){

grid-template-columns: repeat(auto-fill, minmax(28%, 1fr));
grid-auto-flow: column;
grid-auto-columns: minmax(28%, 1fr);
overflow-x: auto;

  }
`;

//==== CAPTURA MOVIMIENTOS ====//
const SearchBarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

//==== SEGUIMIENTO SINIESTROS ====//

export default function Dashboard() {
  const [showModal, setShowModal] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [reminders, setReminders] = useState([]);
  const [actualReminder, setActualReminder] = useState({});
  const navigate = useNavigate();
  const [onListSearch, setOnListSearch] = useState("");
  const [messageData, setMessageData] = useState("");
  const [dataSearched, setDataSearched] = useState([]);
  const { setContract } = useContract();
  const { setSiniester, siniesterState, resetSiniester } = useSiniester();
  const [getLastFiveContracts] = useLazyQuery(GET_SINIESTERS, {
    fetchPolicy: "network-only",
    onCompleted({ getLastFiveSiniestros }) {
      if (getLastFiveSiniestros.statusCode === 200) {
        const result = JSON.parse(getLastFiveSiniestros.response);
        const contracts = result.map((contract, index) => {
          return {
            id: index,
            ramo: contract.ramo,
            numeroContrato: contract.contrato,
            nombreCliente: contract.cliente,
            numeroSiniestro: contract.siniestro,
            ultimoMovimiento: "Generación de siniestro",
            estatus: contract.estatus,
            nombreContrato: contract.nombre_contrato,
            movimientos: contract.movimientos,
          };
        });
        setContracts([...contracts]);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getReminders] = useLazyQuery(GET_REMINDERS, {
    fetchPolicy: "network-only",
    onCompleted({ getReminders }) {
      if (getReminders.statusCode === 200) {
        const result = JSON.parse(getReminders.response);
        const remindersTemp = result.map((reminder, index) => {
          return {
            //id, numeroSiniestro, notaSeguimiento, estatus
            id: index,
            fecha: reminder.fecha,
            recordatorio_id: reminder.recordatorio_id,
            numeroSiniestro: reminder.siniestro_id,
            notaSeguimiento: reminder.nota,
            estatus: reminder.estatus,
            documentales: reminder.reminders
          };
        });
        setReminders([...remindersTemp]);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getSiniestroById] = useLazyQuery(GET_SINEISTROS, {
    fetchPolicy: "network-only",
    onCompleted({ getSiniestroById }) {
      if (getSiniestroById.statusCode === 200) {
        const result = JSON.parse(getSiniestroById.response);
        if (result.length === 0) {
          return setMessageData("Data Not Found") && setDataSearched(result);
        }
        //add name to result
        const resultData = result.map((item) => {
          return {
            ...item,
            nombre: item?.siniestro_id,
          };
        });
        setDataSearched(resultData);
        setMessageData("");
      }
    },
  });

  const [getAllSinisterById, resultsAllSiniesterById] = useLazyQuery(GET_SINISTER_BY_ID, {
    fetchPolicy: "no-cache",
    async onCompleted({ getAllSinisterById }) {
      if (getAllSinisterById.statusCode === 200) {
        const resultData = JSON.parse(getAllSinisterById.response);
        if (resultData.length > 0) {
          await setSiniester({dashboard: true, ...resultData[0]});

        }
      }
    },
  });

  const viewModal = (id) => {
    setActualReminder(reminders[id]);
    setShowModal(true);
  };

  const handleOnChange = (valueInput) => {
    const exprReg = /^[0-9]+$/; // expresión regular, valida números de una cadena
    const validated = exprReg.test(valueInput);
    const dataId = parseInt(valueInput);
    if (validated && dataId > 0) {
      getSiniestroById({
        variables: {
          idSiniestro: dataId,
        },
      });
    }
  };

  useEffect(() => {
    getLastFiveContracts();
    getReminders();
    resetSiniester();
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, []);

  const [updateReminder] = useMutation(UPDATE_REMINDER, {
    onCompleted({ updateReminder }) {
      if (updateReminder.statusCode === 200) {
        getReminders();
      }
    },
    onError(err) {
      console.log(err);
    },
  });
  const [getAllContractByID] = useLazyQuery(GET_CONTRACT, {
    fetchPolicy: "network-only",
    onCompleted({ getAllContractById }) {
      if (getAllContractById.statusCode === 200) {
        const resultFormatJson = JSON.parse(getAllContractById.response);
        setContract({
          ...resultFormatJson[0], 
          noReset: true
        });
      }
    },
  });
  const getSiniesterRedirect = async () => {
    const siniestro_id = actualReminder.numeroSiniestro;

    await getAllSinisterById({
      variables: {
        idSinester: +siniestro_id,
      },
    });
  };
  const contractRedirect = async () => {
    if (siniesterState?.contrato_id) {
      await getAllContractByID({
        variables: {
          idContract: +siniesterState?.contrato_id,
        },
      });
      navigate("/contratos-siniestros");
    }
  };
  useEffect(() => {
    if (resultsAllSiniesterById?.data){
    contractRedirect();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultsAllSiniesterById]);
  const onSubmitModal = async (data) => {
    setShowModal(false);
    const recordatorio_id = actualReminder.recordatorio_id;
    const variables = {
      recordatorio_id,
    };
    await updateReminder({ variables });
    if (data?.redirect) {
      getSiniesterRedirect();
    }
  };
  const setDataSelected = async (data) => {
    const {siniestro_id, contrato_id} = data;
    await getAllContractByID({
      variables: {
        idContract: +contrato_id,
      },
    });
    await getAllSinisterById({
      variables: {
        idSinester: +siniestro_id,
      },
    });
    navigate("/contratos-siniestros");
  };
  return (
    <>
      <ModalWrapper showModal={showModal} closeModal={() => setShowModal(false)}>
        <ModalReminder
          showModal={showModal}
          setShowModal={setShowModal}
          title="Agrega un nuevo cliente"
          handleSubmitRef={onSubmitModal}
          reminder={actualReminder}
        >
          <h1>Modal</h1>
        </ModalReminder>
      </ModalWrapper>
      <Container>
        <Navbar />
        <HeaderWrapper>
          <Header>
            <LeftHeader>
              <Title>Dashboard</Title>
              {/* <Subtitle>¿Qué deseas hacer?</Subtitle>
              <ScheduleText>Today’s schedule</ScheduleText> */}
            </LeftHeader>
            <RightHeader>
              <ButtonHeader
                text="Contrato Nuevo"
                icon={<MoreIcon />}
                link="nuevo-contrato"
              />
              <ButtonHeader
                text="Captura Siniestro"
                icon={<MoreIcon />}
                link="captura-siniestro"
              />
              <ButtonHeader
                text="Archivo "
                icon={<SmallRightIcon />}
                link="/contratos-siniestros"
              />
            </RightHeader>
          </Header>
        </HeaderWrapper>
        <RecentsWrapper>
          <RecentsContainer>
            <RecentsTitle>Recientes</RecentsTitle>
            <Divider />
            <CardsContainer>
              {contracts.map(
                ({
                  id,
                  ramo,
                  numeroContrato,
                  nombreCliente,
                  ultimoMovimiento,
                  estatus,
                  numeroSiniestro,
                  nombreContrato,
                  movimientos
                }) => (
                  <CardRecent
                    id={id}
                    ramo={ramo}
                    numeroContrato={numeroContrato}
                    numeroSiniestro={numeroSiniestro}
                    nombreCliente={nombreCliente}
                    ultimoMovimiento={ultimoMovimiento}
                    estatus={estatus}
                    nombreContrato={nombreContrato}
                    movimientos={movimientos}
                    key={id}
                  />
                )
              )}
            </CardsContainer>
            <RecentsTitle style={{ marginTop: "20px" }}>
              Captura de movimientos
            </RecentsTitle>
            <Divider />
            <SearchBarContainer>
              <SearchBar
                onChange={handleOnChange}
                messageNotFound={"El siniestro no se encuentra registrado"}
                nameKey={"siniestroId"}
                style={{ width: "320px", margin: "20px 0" }}
                placeholder={"Ingresa el número del siniestro"}
                messageData={messageData}
                setMessageData={setMessageData}
                setDataSelected={setDataSelected}
                value={onListSearch}
                setValue={setOnListSearch}
                dataSearched={dataSearched}
                setDataSearched={setDataSearched}
              />
            </SearchBarContainer>
            <RecentsTitle>Seguimiento de Siniestros</RecentsTitle>
            <Divider />
            <CardsContainer>
              {reminders.map(
                ({ id, numeroSiniestro, notaSeguimiento, estatus, documentales }) => (
                  <CardSiniestros
                    onClicked={viewModal}
                    id={id}
                    numeroSiniestro={numeroSiniestro}
                    notaSeguimiento={notaSeguimiento}
                    documentales={documentales}
                    estatus={estatus}
                    key={id}
                  />
                )
              )}
            </CardsContainer>
          </RecentsContainer>
        </RecentsWrapper>
      </Container>
      <Footer />
    </>
  );
}
